import { isAfter } from 'date-fns';

import { WorkLog } from 'domain/entities/Worklog';

export const workLogDateComparator = (a: WorkLog, b: WorkLog) =>
  isAfter(a.startedAt, b.startedAt) ? 1 : -1;
